import { createStore } from "vuex";

const store = createStore({
  modules: {
    auth: {
      namespaced: true,
      state: () => ({
        token: localStorage.getItem("token") || null,
        user: JSON.parse(localStorage.getItem("user")) || null,
      }),
      mutations: {
        SET_TOKEN(state, token) {
          state.token = token;
        },
        SET_USER(state, user) {
          state.user = user;
        },
        LOGOUT(state) {
          state.token = null;
          state.user = null;
          localStorage.removeItem("token");
          localStorage.removeItem("user");
        },
      },
      getters: {
        isAuthenticated: (state) => !!state.token,
        user: (state) => state.user,
      },
    },
  },
});

export default store;
